import { Outlet, useLocation } from 'react-router-dom';
import { PublicHeader } from '../components/shared/PublicHeader';
import { PublicFooter } from '../components/shared/PublicFooter';

export function PublicLayout() {
  const { pathname } = useLocation();
  const footerCompleto = pathname === '/';

  return (
    <div className="flex flex-col min-h-screen bg-bg">
      <PublicHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <PublicFooter completo={footerCompleto} />
    </div>
  );
}
